(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Aeropuerto', Aeropuerto);

    Aeropuerto.$inject = ['$resource'];

    function Aeropuerto ($resource) {
        var resourceUrl =  'api/aeropuertos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
